import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import Container from "@components/Atomic/Container/Container";
import { clsx } from "clsx";
import React from "react";
import { FeaturedCollectionCarousel } from "./FeaturedCollectionCarousel";
import { withFeaturedCollection } from "./withFeaturedCollection";

const OuterWrapper = withFocusRing((props: any) => (
  <div
    {...props}
    className={clsx(props.className, "smd:pb-tera relative py-maxi")}
  />
));
const TabHeader = withFocusRing((props: any) => (
  <div
    {...props}
    className={clsx(props.className, "mt-micro flex items-baseline md:mt-zero")}
  />
));
const Title = withFocusRing((props: any) => (
  <button
    {...props}
    className={clsx(
      props.className,
      "ml-mini cursor-pointer font-medium leading-caption first:ml-zero hover:text-secondary hover:opacity-100",
      props.active ? "border-b" : "opacity-60",
    )}
  />
));

export const FeaturedCollection = withFeaturedCollection(
  ({
    autoDelay,
    heading,
    styles,
    featuredCollectionContents,
    tabTitle,
    handleTabClick,
    activeTab,
    _key,
  }) => (
    <Container
      styles={styles}
      data-component-type="section-featured-collection"
    >
      <OuterWrapper tabIndex={0}>
        <div className="flex flex-col pl-midi md:absolute md:z-10 md:flex-row md:items-center xl:pl-tera">
          <div className="rte mr-midi">{heading}</div>
          {tabTitle && tabTitle.length > 0 ? (
            <TabHeader>
              {tabTitle.map(({ title }) => (
                <Title
                  key={`${title}-${_key}`}
                  active={activeTab === title}
                  onClick={() => handleTabClick(title)}
                  role="tab"
                  aria-selected={`${activeTab}_${_key}` === `${title}_${_key}`}
                  id={`${title?.toLowerCase()}_${_key}`}
                >
                  {title}
                </Title>
              ))}
            </TabHeader>
          ) : null}
        </div>
        <FeaturedCollectionCarousel
          _key={_key}
          autoDelay={autoDelay}
          activeTab={activeTab}
          featuredCollectionContents={featuredCollectionContents}
        />
      </OuterWrapper>
    </Container>
  ),
);
